import { createSlice } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";
import { SORT_DIRECTION } from "../../../utils/vars";

export const CUSTOM_REPORTS_REDUCER_NAME = "reports";

const initialState = {
  page: 0,
  take: 20,
  totalCount: 0,
  sort: {
    direction: SORT_DIRECTION.DESC,
    type: "DATE",
  },
  data: [],
  filters: {
    author: "",
    reportName: "",
    status: "",
    period: "",
    periodCount: "",
    startDate: "",
    endDate: "",
    exactDate: "",
  },
};

const customReportsSlice = createSlice({
  name: CUSTOM_REPORTS_REDUCER_NAME,
  initialState,
  reducers: {
    setReportsData: (state, { payload }) => {
      state.data = [...payload];
    },
    setReportsPage: (state, { payload }) => {
      state.page = payload;
    },
    setReportsTake: (state, { payload }) => {
      state.take = payload;
    },
    setReportsTotalCount: (state, { payload }) => {
      state.totalCount = payload;
    },
    setReportsFilters: (state, { payload }) => {
      const temp = { ...state.filters };
      state.filters = { ...temp, ...payload };
    },
    setReportsSort: (state, { payload }) => {
      state.sort = payload;
    },
    setReportStatus: (state, { payload }) => {
      const report = state.data.find((item) => item.id === payload.id);

      if (report) {
        report.status = payload.status;
      }
    },
    updateReport: (state, { payload }) => {
      const report = state.data.find((item) => item.id === payload.id);

      if (report) {
        Object.assign(report, payload);
      }
    },
    clearReports: (state) => {
      state.page = initialState.page;
      state.take = initialState.take;
      state.totalCount = initialState.totalCount;
      state.sort = initialState.sort;
      state.data = initialState.data;
      state.filters = initialState.filters;
    },
  },
});

export const {
  clearReports,
  setReportsData,
  setReportsPage,
  setReportsTake,
  setReportsTotalCount,
  setReportsFilters,
  setReportsSort,
  setReportStatus,
  updateReport,
} = customReportsSlice.actions;

export default customReportsSlice.reducer;

export const useSelectPageReports = () => {
  return useSelector((state) => state[CUSTOM_REPORTS_REDUCER_NAME].page);
};

export const useSelectTakeReports = () => {
  return useSelector((state) => state[CUSTOM_REPORTS_REDUCER_NAME].take);
};

export const useSelectReportsData = () => {
  return useSelector((state) => state[CUSTOM_REPORTS_REDUCER_NAME].data);
};

export const useSelectTotalCountReports = () => {
  return useSelector((state) => state[CUSTOM_REPORTS_REDUCER_NAME].totalCount);
};

export const useSelectFiltersReports = () => {
  return useSelector((state) => state[CUSTOM_REPORTS_REDUCER_NAME].filters);
};

export const useSelectSortReports = () => {
  return useSelector((state) => state[CUSTOM_REPORTS_REDUCER_NAME].sort);
};
